import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("trq_token");
    if (!token) {
      setLoading(false);
      return;
    }
    // Always refresh user from server so role/is_owner/disabled stay in sync
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("trq_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("trq_token");
        localStorage.removeItem("trq_user");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("trq_token", data.token);
    localStorage.setItem("trq_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("trq_token");
    localStorage.removeItem("trq_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
